import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DEFAULT_LOCALE, isSupportedLocale } from '../../config/localeConfig';
import { MARKET_DEFAULT_LOCALE, isSupportedMarket } from '../../config/marketConfig';

const LOCALE_COOKIE_KEY = 'pv_locale';
const MARKET_COOKIE_KEY = 'pv_market';

function getCookie(name) {
  if (typeof document === 'undefined') return null;

  const match = document.cookie.match(
    new RegExp('(^|;\\s*)' + name.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\$&') + '=([^;]*)')
  );

  return match ? decodeURIComponent(match[2]) : null;
}

function getCountryFromCf() {
  if (typeof window === 'undefined') return null;

  const country =
    window.__CF_IPCOUNTRY__ ||
    window.__APP_COUNTRY__ ||
    document.documentElement?.dataset?.country ||
    null;

  return typeof country === 'string' ? country.toUpperCase() : null;
}

function detectLocaleFromNavigator() {
  if (typeof navigator === 'undefined') return null;

  const languages = Array.isArray(navigator.languages) ? navigator.languages : [];
  const candidates = [...languages, navigator.language].filter(Boolean);

  for (const candidate of candidates) {
    const short = String(candidate).toLowerCase().split('-')[0];
    if (isSupportedLocale(short)) {
      return short;
    }
  }

  return null;
}

function resolveInitialLocale() {
  const cookieLocale = getCookie(LOCALE_COOKIE_KEY);
  if (isSupportedLocale(cookieLocale)) {
    return cookieLocale;
  }

  const cookieMarket = getCookie(MARKET_COOKIE_KEY);
  if (cookieMarket && isSupportedMarket(cookieMarket) && MARKET_DEFAULT_LOCALE[cookieMarket]) {
    return MARKET_DEFAULT_LOCALE[cookieMarket];
  }

  const geoCountry = getCountryFromCf();
  if (geoCountry && isSupportedMarket(geoCountry) && MARKET_DEFAULT_LOCALE[geoCountry]) {
    return MARKET_DEFAULT_LOCALE[geoCountry];
  }

  const browserLocale = detectLocaleFromNavigator();
  if (browserLocale && isSupportedLocale(browserLocale)) {
    return browserLocale;
  }

  return DEFAULT_LOCALE;
}

export default function GeoRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const locale = resolveInitialLocale();
    const search = location.search || '';
    const hash = location.hash || '';
    navigate(`/${locale}${search}${hash}`, { replace: true });
  }, [navigate, location.search, location.hash]);

  return null;
}
